<template>
  <div class="preloader">
    <div class="ozient-folding-cube">
      <div class="ozient-cube1 ozient-cube"></div>
      <div class="ozient-cube2 ozient-cube"></div>
      <div class="ozient-cube4 ozient-cube"></div>
      <div class="ozient-cube3 ozient-cube"></div>
    </div>
  </div>
  <div class="main-wrapper">
    <HomeView/>
    <VueFooter/>
    <ProgressWrap/>
  </div>
</template>
<script>
import $ from "jquery";
import VueFooter from "@/components/VueFooter";
import ProgressWrap from "@/components/ProgressWrap";
import HomeView from "@/views/HomeView";
export default {
  components: {HomeView, ProgressWrap, VueFooter},
  created() {
    //   Preloader Active code
    window.addEventListener("load", function () {
       $ ('.main-wrapper').fadeIn('slow');
      $ ('.ozient-folding-cube').fadeOut(500, function () {
       $ ('.preloader').remove();
      });
    });

  }
}
</script>
<style>

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

/*nav a.router-link-exact-active {
  color: #42b983;
}*/
</style>
